/**
 * Hook to access portal module permissions
 *
 * Provides utilities to check if the current user can access specific portal modules
 */

import { useMemo } from 'react';
import type { PortalModule } from '@/types/investor';
import { useMe } from './useMe';

/**
 * Hook to check portal module access
 */
export function usePortalAccess() {
  const { data: me, isLoading } = useMe();

  const accessibleModules = useMemo(() => {
    return new Set(me?.accessible_modules ?? []);
  }, [me?.accessible_modules]);

  const canAccess = (module: PortalModule): boolean => {
    return accessibleModules.has(module);
  };

  return {
    accessibleModules,
    canAccess,
    isLoading,
  };
}
